<template>
  <v-dialog v-model="showDialog" max-width="800px" persistent scrollable>
    <v-card>
      <v-toolbar color="primary" dark flat>
        <!-- <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
        <v-toolbar-title class="font-weight-bold">
          <v-icon left>mdi-file-document-outline</v-icon>
          Detalhes do Lançamento AEE
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-5">
        <div v-if="!lancamento">
          <p>Nenhum lançamento selecionado.</p>
        </div>
        <div v-else>
          <v-row dense>
            <v-col cols="12" md="6">
              <info-item icon="mdi-calendar" label="Data" :value="lancamento.data_formatada" />
            </v-col>
            <v-col cols="12" md="6">
              <info-item
                icon="mdi-label-outline"
                label="Bimestre"
                :value="lancamento.bimestre_desc"
              />
            </v-col>
            <v-col cols="12" md="6">
              <info-item
                icon="mdi-clock-outline"
                label="Horário"
                :value="lancamento.horario?.descricao || 'N/A'"
              />
            </v-col>
            <v-col cols="12" md="6">
              <info-item
                icon="mdi-account-circle"
                label="Professor(es)"
                :value="listaProfessores"
              />
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Tipo de atendimento realizado
              </h3>
              <v-card outlined>
                <v-card-text>
                  <ul v-if="tiposAtendimentoFiltrados.length" class="pl-4">
                    <li
                      v-for="(item, index) in tiposAtendimentoFiltrados"
                      :key="index"
                      class="text-body-1 text-justify"
                    >
                      {{ item }}
                    </li>
                  </ul>
                  <p v-else class="text-body-1 text-justify" style="white-space: pre-wrap">
                    Tipo de atendimento não informado
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Habilidades trabalhadas
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{ lancamento.horas_trabalhadas || "Habilidades trabalhadas não informadas" }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Descrição dos atendimentos/atividades
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{
                      lancamento.descricao_atividades || "Habilidades trabalhadas não informadas"
                    }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Avanços observados
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{ lancamento.avancos_observados || "Habilidades trabalhadas não informadas" }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Dificuldades observadas
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{
                      lancamento.dificuldades_observadas || "Habilidades trabalhadas não informadas"
                    }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Frequência e participação nas atividades
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{
                      lancamento.participacao_atividades || "Habilidades trabalhadas não informadas"
                    }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">
                <v-icon left color="primary">mdi-text-box-check-outline</v-icon>
                Frequência e envolvimento da família
              </h3>
              <v-card outlined>
                <v-card-text>
                  <p class="text-body-1 text-justify" style="white-space: pre-wrap">
                    {{
                      lancamento.envolvimento_da_familia || "Habilidades trabalhadas não informadas"
                    }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog" class="mr-2 text-white" color="primary">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InfoItem from "./InfoItem.vue";

export default {
  name: "EModalDetalhesLancamentoAEE",
  components: {
    InfoItem,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    lancamento: {
      type: Object,
      default: null,
    },
    matricula: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      },
    },

    tiposAtendimentoFiltrados() {
      if (!this.lancamento || !Array.isArray(this.lancamento.tipo_atendimento_realizado)) {
        return [];
      }

      return this.lancamento.tipo_atendimento_realizado.filter((item) => item && item.trim());
    },

    listaProfessores() {
      const gestoes = this.matricula?.turma?.gestao_de_aulas_a_e_e;

      if (!Array.isArray(gestoes) || !gestoes.length) {
        return "Não informado";
      }

      return gestoes
        .map((g) => g?.professor?.nome)
        .filter(Boolean)
        .join(", ");
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
.info-item {
  margin-bottom: 16px;
}

.text-justify {
  text-align: justify;
}
</style>
